<template>
  <div class="entity-vip">
    <div class="filter-container">
      <el-button class="filter-item" style="margin-left: 10px" type="primary" icon="el-icon-edit" @click="handleCreate">
        新建
      </el-button>
    </div>

    <!-- 数据列表区 -->
    <el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%; align: center">
      <el-table-column prop="level" label="会员等级" align="center">
      </el-table-column>
      <el-table-column prop="name" label="会员名称" align="center">
      </el-table-column>
      <el-table-column prop="discount" label="折扣" align="center">
      </el-table-column>
      <el-table-column prop="needConsumption" label="所需消费" width="150" align="center">
      </el-table-column>
      <el-table-column prop="needPoints" label="所需积分" align="center">
      </el-table-column>
      <el-table-column prop="remarks" label="备注" width="200" align="center">
      </el-table-column>
      <el-table-column prop="operator" label="操作" width="200" align="center">
        <template v-slot:="{ row, $index }">
          <el-button type="primary" size="mini" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新建(编辑)VIP -->
    <el-dialog :visible.sync="formVisable" :title="dialogType ==='edit'?'编辑VIP':'新建VIP'"  >
      <el-form :model="vip" :rules="rules" ref="vip">
        <el-form-item label="会员等级" prop="level">
          <el-input v-model="vip.level"></el-input>
        </el-form-item>
        <el-form-item label="会员名称" prop="name">
          <el-input v-model.trim="vip.name" maxlength="20" @input="e => vip.name = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"
           @keyup.native="trimLr(vip.name)">
          </el-input>
        </el-form-item>
        <el-form-item label="会员折扣" prop="discount">
          <el-input v-model="vip.discount"></el-input>
        </el-form-item>
        <el-form-item label="所需消费" prop="needConsumption">
          <el-input v-model="vip.needConsumption"></el-input>
        </el-form-item>
        <el-form-item label="所需积分" prop="needPoints">
          <el-input v-model="vip.needPoints"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="vip.remarks"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="footer">
        <el-button @click="formVisable = false">取消</el-button>
        <el-button type="primary" @click="confirmAdd()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from "@/components/common/Pagination";
  import {
    vipList,
    vipAdd,
    vipChange,
    vipDel
  } from "@/api/vip";

  export default {
    name: "EntityVip",
    components: {
      Pagination,
    },
    data() {
      return {
        listLoading: true,
        listData: [],
        formVisable: false,
        dialogType: 'new',
        vip: {
          level: undefined,
          name: undefined,
          discount: undefined,
          needConsumption: undefined,
          needPoints: undefined,
          remarks: undefined,
        },
        rules: {
          level: [{
              required: true,
              message: '请输入会员等级',
              trigger: 'blur'
            },
            {
              pattern: /^(0|[1-9]\d?|100)$/,
              message: '范围在0-100',
              trigger: 'blur'
            }
          ],
          name: [{
            required: true,
            message: '请输入会员名称',
            trigger: 'blur'
          }, ],
          discount: [{
              required: true,
              message: '请输入会员折扣',
              trigger: 'blur'
            },
            {
              pattern: /^(0|[1-9]\d?|10)$/,
              message: '范围在0-10',
              trigger: 'blur'
            }
          ],
          needConsumption: [{
              required: true,
              message: '请输入所需消费',
              trigger: 'blur'
            },
            {
              validator(r, v, b) {
                (/^[0-9]*\.?[0-9]+$/).test(v) ? b() : b(new Error('请填写数字'))
              }
            }
          ],
          needPoints: [{
            required: true,
            message: '请输入所需积分',
            trigger: 'blur'
          }, {
              // pattern: /^(0|[1-9]\d?|100)$/,
              pattern: /^[1-9]\d*$/,
              message: '大于0的整数',
              trigger: 'blur'
            }]
        }
      };
    },
    methods: {

      /**
       * @param {Object} val
       * 去除字符中间空格
       */
      trimLr(val){
        this.vip.name = val.replace(/\s+/g, "");
      },

      handleFilter() {
        this.listLoading = true
        vipList().then(res => {
          this.listLoading = false
          if (res.result == '200') {
            this.listData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
      },
      /**
       * @param {Object} done
       * 点击新建框外提示
       */
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      handleCreate() {
        this.vip = {}
        this.dialogType = 'add';
        this.formVisable = true;
      },
      handleEdit(row) {
        this.vip = row
        this.dialogType = 'edit'
        this.formVisable = true
      },
      handleDelete(row) {
        this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vipDel(row.id).then(res => {
            if (res.result == '200') {
              this.$message.success(res.message)
              this.handleFilter()
              this.formVisable = false
            } else {
              this.$message.error(res.message)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      confirmAdd() {
        this.$refs['vip'].validate((valid) => {
          if (valid) {
            if (this.dialogType == 'add') {
              vipAdd(this.vip).then(res => {
                if (res.result == '200') {
                  this.$message.success(res.message)
                  this.handleFilter()
                  this.formVisable = false
                } else {
                  this.$message.error(res.message)
                }
              })
            } else {
              vipChange(this.vip).then(res => {
                if (res.result == '200') {
                  this.$message.success(res.message)
                  this.handleFilter()
                  this.formVisable = false
                } else {
                  this.$message.error(res.message)
                }
              })
            }
          } else {
            this.$message.warning("检查输入.")
            return false;
          }
        });
      }
    },
    mounted() {
      this.handleFilter()
    },
  };
</script>

<style scoped>
</style>
